import { render } from "./NkDataList.vue?vue&type=template&id=0f6fa661"
import script from "./NkDataList.vue?vue&type=script&lang=js"
export * from "./NkDataList.vue?vue&type=script&lang=js"
script.render = render

export default script